// extracted by mini-css-extract-plugin
export default {"picslide":"index_picslide_0-S2R","dot":"index_dot_4HHtM","current":"index_current_ksxbw"};